<!--
    描述：审计作业模板
    时间：2021-05-17
    Created by 王帅
-->
<template>
	<div class="primary-layout">
		<div class="primary-header">
			<div class="left-text">
				审计作业模板维护
				<el-tooltip placement="right"
							effect="light">
					<div slot="content">
						<p>审计作业模板维护:管理员创建审计作业模板，</p>
						<p class="mt10">填写相应的审计作业要求:运营人员在审计作业</p>
						<p class="mt10">中根据相应要求做相应的审计事项。</p>
					</div>
					<svg-icon class="ml5"
							  icon-class="wenhao"></svg-icon>
				</el-tooltip>
			</div>
			<div class="btnGroups">
				<el-input size="small"
						  placeholder="请输入事项名称"
						  v-model="searchName"
						  @keyup.enter.native="handleSearch"
						  class="w300">
					<template slot="append">
						<el-button size="small"
								   class="btn-blue"
								   @click="handleSearch">查询</el-button>
					</template>
				</el-input>
				<el-button size="small"
						   class="btn-blue ml10">列过滤</el-button>
				<el-button size="small"
						   class="btn-blue"
						   :disabled="currentMenuId === ''"
						   @click="handleMatter('add')"
						   v-if="roleBtns.includes('addItem')">新增事项</el-button>
			</div>
		</div>
		<div class="primary-content">
			<wSplit class="h100"
					v-model="splitV">
				<!-- 左侧树形 -->
				<div class="h100 left-pane"
					 slot="left"
					 v-loading="treeLoading">
					<el-tree class="left-tree"
							 ref="leftTree"
							 :data="leftData"
							 :props="defaultProps"
							 default-expand-all
							 :expand-on-click-node="false"
							 node-key="id"
							 highlight-current
							 @node-click="handleNodeClick">
						<p class="custom-tree-node text-overflow"
						   slot-scope="{ node, data }">
							<el-tooltip :content="node.label"
										:disabled="node.label && node.label.length < 15">
								<span class="text-overflow">
									<i class="el-icon-folder-opened"></i>
									{{ node.label }}
								</span>
							</el-tooltip>
							<span>
								<el-button type="text"
										   size="mini"
										   icon="el-icon-plus"
										   v-if="roleBtns.includes('add') && data.id === '0'"
										   @click.stop="() => handleNodeTool('append', data)">
								</el-button>

								<el-button type="text"
										   size="mini"
										   v-if="roleBtns.includes('enable') && data.id !== '0'"
										   :disabled="data.status === 1"
										   @click.stop="() => handleNodeTool('status', data)">
									<svg-icon icon-class="qiyong"></svg-icon>
								</el-button>
								<el-button type="text"
										   size="mini"
										   v-if="roleBtns.includes('disabled') && data.id !== '0'"
										   :disabled="data.status !== 1"
										   @click.stop="() => handleNodeTool('status', data)">
									<svg-icon icon-class="jinyong"></svg-icon>
								</el-button>
								<el-button type="text"
										   size="mini"
										   v-if="roleBtns.includes('delete') && data.id !== '0'"
										   @click.stop="() => handleNodeTool('remove', data)">
									<svg-icon icon-class="delete"></svg-icon>
								</el-button>
							</span>
						</p>
					</el-tree>
				</div>
				<!-- 右侧表格 -->
				<div class="h100 right-pane"
					 slot="right">
					<div class="h100">
						<vxe-table ref="dataTable"
								   :data="tableData"
								   height="auto"
								   async-resize
								   resizable
								   border
								   show-overflow
								   show-header-overflow
								   :loading="loading"
								   align="center"
								   header-align="center">
							<vxe-table-column title="序号"
											  width="70"
											  type="seq">
							</vxe-table-column>
							<vxe-table-column title="事项名称"
											  field="sname"
											  min-width="200"
											  header-align="center"
											  align="left">
								<template #default="{ row, rowIndex }">
									<span class="blue-text vxe-cell--label"
										  @click="handleMatter('view', row)">
										{{ row.sname }}
									</span>
								</template>
							</vxe-table-column>
							<vxe-table-column title="内容"
											  field="content"
											  min-width="250"
											  header-align="center"
											  align="left">
							</vxe-table-column>
							<vxe-table-column title="审计要求"
											  field="requires"
											  width="110"
											  align="left">
							</vxe-table-column>
							<vxe-table-column title="依据"
											  field="gist"
											  width="200"
											  align="left"
											  header-align="center">
							</vxe-table-column>
							<vxe-table-column title="评价方式"
											  field="typeName"
											  width="180">
							</vxe-table-column>
							<!-- <vxe-table-column
                                title="审计类型"
                                v-if="currentMenuId === ''"
                                field="auditTypeName"
                                width="150"
                            >
                            </vxe-table-column> -->
							<vxe-table-column title="是否生效"
											  field="status"
											  width="100">
								<template #default="{ row }">
									<vxe-switch v-if="roleBtns.includes('status')"
												v-model="row.status"
												:disabled="isDisabled || currentStatus !== 1"
												open-label="是"
												:open-value="1"
												close-label="否"
												:close-value="0"
												@change="handleNodeTool('status', row, true)"></vxe-switch>
								</template>
							</vxe-table-column>
							<vxe-table-column title="适用任务类型"
											  field="applysName"
											  width="150">
							</vxe-table-column>
							<vxe-table-column title="顺序"
											  width="150">
								<template #default="{ row, rowIndex }">
									<el-button type="primary"
											   size="mini"
											   @click="handleMove('up', row)"
											   :disabled="isDisabled || rowIndex === 0 || currentMenuId === ''"
											   icon="el-icon-arrow-up"></el-button>
									<el-button type="primary"
											   size="mini"
											   @click="handleMove('down', row)"
											   :disabled="isDisabled || rowIndex === tableData.length - 1 ||currentMenuId === ''"
											   icon="el-icon-arrow-down"></el-button>
								</template>
							</vxe-table-column>
							<vxe-table-column title="操作"
											  align="center"
											  width="160">
								<template #default="{ row }">
									<el-button class="table-btn"
											   size="small"
											   round
											   plain
											   type="success"
											   v-if="roleBtns.includes('editItem')"
											   @click="handleMatter('edit', row)">
										<svg-icon icon-class="form-edit"></svg-icon>编辑
									</el-button>
									<el-button class="table-btn"
											   size="small"
											   type="danger"
											   round
											   plain
											   icon="el-icon-delete"
											   v-if="roleBtns.includes('deleteItem')"
											   @click="handleMatter('delete', row)">删除</el-button>
								</template>
							</vxe-table-column>
						</vxe-table>
					</div>
				</div>
			</wSplit>
		</div>

		<!-- 弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.show"
				   :width="dialogObj.width"
				   :close-on-click-modal="false"
				   center>
			<!-- 新增模板 -->
			<template v-if="dialogObj.show && dialogObj.type === 'template'">
				<el-input class="is-required-item"
						  v-model="addParams.sname"
						  maxlength="50"
						  show-word-limit
						  placeholder="请输入模板名称"></el-input>
			</template>

			<!-- 新增、编辑事项 -->
			<template v-if="dialogObj.show && dialogObj.type === 'matter'">
				<el-form :model="addParams"
						 :rules="matterRules"
						 ref="matterForm"
						 label-width="110px"
						 :show-message="false">
					<el-form-item label="名称"
								  prop="sname">
						<el-input placeholder="请输入审计类型名称"
								  v-model="addParams.sname"
								  maxlength="50"
								  show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="内容"
								  prop="content">
						<el-input type="textarea"
								  :autosize="{ minRows: 2 }"
								  placeholder="请输入内容"
								  v-model="addParams.content"
								  maxlength="200"
								  show-word-limit>
						</el-input>
					</el-form-item>
					<el-form-item label="审计要求"
								  prop="requires">
						<el-input type="textarea"
								  :autosize="{ minRows: 2 }"
								  placeholder="请输入内容"
								  v-model="addParams.requires"
								  maxlength="200"
								  show-word-limit>
						</el-input>
					</el-form-item>
					<el-form-item label="依据"
								  prop="gist">
						<el-input placeholder="请输入依据"
								  v-model="addParams.gist"
								  maxlength="50"
								  show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="评价方式"
								  prop="type">
						<el-select v-model="addParams.type">
							<el-option v-for="(item, index) in projectDict.pjfs"
									   :key="'type' + index"
									   :label="item.sname"
									   :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="适用任务类型"
								  prop="applysArr">
						<el-checkbox-group v-model="addParams.applysArr">
							<el-checkbox v-for="(item, index) in projectDict.sjrwlx"
										 :key="'applys' + index"
										 :label="item.value">{{ item.sname }}</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item label="备注"
								  prop="remark">
						<el-input type="textarea"
								  :autosize="{ minRows: 2 }"
								  placeholder="请输入内容"
								  v-model="addParams.remark"
								  maxlength="200"
								  show-word-limit>
						</el-input>
					</el-form-item>
				</el-form>
			</template>

			<!-- 查看事项 -->
			<template v-if="dialogObj.show && dialogObj.type === 'view'">
				<div class="matter-view-main">
					<div class="matter-view-header">{{ currentRowName }}</div>
					<div class="matter-view-content">
						<vxe-grid class="reverse-table"
								  v-bind="gridOptions">
							<template #default="{ row }">{{
                                row.col0 === "是否生效："
                                    ? row.col1 === 1
                                        ? "是"
                                        : "否"
                                    : row.col1
                            }}</template>
						</vxe-grid>
					</div>
				</div>
			</template>

			<!-- 底部按钮 -->
			<div slot="footer"
				 v-if="dialogObj.type !== 'view'">
				<el-button size="small"
						   class="btn"
						   @click="dialogObj.show = false">取 消</el-button>
				<el-button size="small"
						   class="btn btn-blue"
						   type="primary"
						   :loading="btnLoading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import * as Api from 'api/basicManage/auditTemplate.js'
import { mapState } from 'vuex'
import { $deepCopy } from 'utils/tools.js'
export default {
	name: '',
	data() {
		return {
			splitV: 0.3,
			searchName: '',
			// 左侧树结构配置
			currentMenuId: '', // 左侧菜单id
			currentStatus: 1, // 左侧菜单状态
			currentRowName: 1, // 左侧菜单名称
			treeLoading: false,
			defaultProps: {
				children: 'children',
				label: 'sname',
			},
			leftData: [
				{
					sname: '审计作业模板维护',
					disabled: true,
					id: '0',
					children: [],
				},
			],
			// 右侧表格
			tableData: [],
			loading: false,
			// 新增弹窗
			dialogObj: {
				show: false,
				title: '审计作业模板维护',
				width: '400px',
				type: '',
			},
			btnLoading: false,
			addParams: {
				id: '',
				sname: '',
				pid: '',
				content: '',
				requires: '',
				gist: '',
				type: '',
				applys: '',
				applysArr: [],
				sort: '',
				remark: '',
			},
			matterRules: {
				sname: [{ required: true, trigger: 'blue' }],
				content: [{ required: true, trigger: 'blue' }],
				requires: [{ required: true, trigger: 'blue' }],
				gist: [{ required: true, trigger: 'blue' }],
				type: [{ required: true, trigger: 'change' }],
				applysArr: [
					{ required: true, type: 'array', trigger: 'change' },
				],
			},
			// 反转表格
			gridOptions: {
				border: false,
				showHeader: false,
				columns: [],
				data: [],
			},
		}
	},
	created() {
		// 获取左侧菜单树
		this.getLeftData()
	},
	methods: {
		// 获取左侧菜单树
		getLeftData() {
			this.leftData[0].children = []
			Api.getLeftMenu()
				.then((res) => {
					this.leftData[0].children = res.data
					let keyId =
						this.currentMenuId === '' ? '0' : this.currentMenuId
					let node = res.data.find((x) => x.id === keyId)
					let clickNode = node ? node : this.leftData[0]

					// 设置高亮
					setTimeout(() => {
						if (this.$refs.leftTree) {
							this.handleNodeClick(clickNode)
							this.$refs.leftTree.setCurrentKey(keyId)
						}
					}, 100)
				})
				.catch((err) => {})
		},

		// 左侧树结构点击
		handleNodeClick(data) {
			// 根节点 传 ''
			let pid = data.id === '0' ? '' : data.id
			// 保存当前节点属性
			this.currentMenuId = pid
			this.currentStatus = data.status
			this.currentRowName = data.sname
			this.searchName = ''

			if (data.id === '0') {
				return
			}
			this.handleSearch(true)
		},

		// 右侧查询
		handleSearch(hideLoading) {
			if (this.currentMenuId === '') {
				return
			}
			this.loading = hideLoading ? false : true

			Api.getRightData({
				pid: this.currentMenuId,
				sname: this.searchName,
			})
				.then((res) => {
					this.loading = false
					this.tableData = res.data
				})
				.catch((err) => {
					this.loading = false
				})
		},

		// 左侧树 新增、删除
		async handleNodeTool(type, data, isRight) {
			switch (type) {
				// 添加
				case 'append':
					this.dialogObj.show = true
					this.dialogObj.type = 'template'
					this.dialogObj.width = '400px'
					this.dialogObj.title = '审计作业模板维护'
					this.addParams.sort = this.leftData[0].children.length + 1
					this.addParams.pid = '0'
					break
				// 删除
				case 'remove':
					// 先查看看 该菜单下 是否有children
					let result = await Api.getRightData({ pid: data.id })

					if (result.data.length > 0) {
						this.$message.warning(
							'该目录下有子事项，请先删除子事项！'
						)
						return
					}

					let status = await this.$deleteConfirm('该模板')
					if (status) {
						let params = {
							id: data.id,
							pid: data.pid,
							sort: data.sort,
						}
						this.treeLoading = true
						Api.removeTemplate(params)
							.then((res) => {
								this.treeLoading = false

								// 如果删除时 正选中，删除后 查询所有
								if (data.id === this.currentMenuId) {
									this.currentMenuId = ''
								}

								// 重新加载左侧树
								this.getLeftData()
							})
							.catch((err) => {
								this.treeLoading = false
							})
					}
					break
				// 启用、禁用
				case 'status':
					this.treeLoading = true
					let _status = !isRight
						? data.status
						: data.status === 1
						? 0
						: 1
					let _type = isRight ? '2' : '1'

					// 如果是左侧启用、禁用 提示
					if (!isRight) {
						let text = _status === 1 ? '禁用' : '启用'
						this.$confirm(
							`确认${text}？该目录下所有事项都${text}！`,
							'提示',
							{
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning',
							}
						)
							.then(() => {
								// 接口删除
								Api.changeStatus({
									id: data.id,
									status: _status,
									type: _type,
								})
									.then((res) => {
										this.treeLoading = false

										// 重载树
										if (!isRight) {
											this.getLeftData()
										} else {
											// 重载右侧
											this.handleSearch()
										}
									})
									.catch((err) => {
										this.treeLoading = false
									})
							})
							.catch(() => {
								this.treeLoading = false
							})
					} else {
						Api.changeStatus({
							id: data.id,
							status: _status,
							type: _type,
						})
							.then((res) => {
								this.treeLoading = false

								// 重载树
								if (!isRight) {
									this.getLeftData()
								} else {
									// 重载右侧
									this.handleSearch()
								}
							})
							.catch((err) => {
								this.treeLoading = false
							})
					}
					break
			}
		},

		// 右侧新增、编辑、删除、查看
		async handleMatter(type, row) {
			switch (type) {
				case 'add':
					if (this.currentMenuId && this.currentMenuId !== '') {
						this.dialogObj.show = true
						this.dialogObj.type = 'matter'
						this.dialogObj.width = '800px'
						this.dialogObj.title = '新增事项'

						// 参数相关
						this.addParams.sort = this.tableData.length + 1
						this.addParams.pid = this.currentMenuId
					}
					break
				// 编辑
				case 'edit':
					this.dialogObj.show = true
					this.dialogObj.type = 'matter'
					this.dialogObj.width = '800px'
					this.dialogObj.title = '编辑事项'

					// 赋值回显
					this.$nextTick(() => {
						setTimeout(() => {
							this.addParams = this.$utils.clone(row, true)
							this.$set(
								this.addParams,
								'applysArr',
								this.addParams.applys.split(',')
							)
						}, 100)
					})
					break
				// 删除
				case 'delete':
					let status = await this.$deleteConfirm('该事项')
					if (status) {
						let params = {
							id: row.id,
							pid: row.pid,
							sort: row.sort,
						}
						this.loading = true
						// 移除
						Api.removeTemplate(params)
							.then((res) => {
								// 重新查询右侧
								this.handleSearch()
							})
							.catch((err) => {
								this.loading = false
							})
					}
					break
				// 查看事项
				case 'view':
					this.dialogObj.show = true
					this.dialogObj.type = 'view'
					this.dialogObj.width = '800px'
					this.dialogObj.title = '查看事项'

					// 接口回显
					Api.getDetail({ id: row.id })
						.then((res) => {
							this.gridOptions.data.push(res.data)

							// 反转表格
							this.reverseTable(
								this.columns,
								this.gridOptions.data
							)
						})
						.catch((err) => {})
					break
			}
		},

		// 右侧顺序切换
		handleMove(type, row) {
			let params = {
				id: row.id,
				type: type === 'up' ? '1' : '2', // 1 上移， 2 下移
				sort: row.sort, // 当前排序
				pid: row.pid,
			}
			this.loading = true
			Api.changeSort(params)
				.then((res) => {
					// 重载右侧表格
					this.handleSearch()
				})
				.catch((err) => {
					this.loading = false
				})
		},

		// 确认新增模板
		doSave() {
			this.btnLoading = true
			let params = this.$utils.clone(this.addParams, true)
			params.sname = params.sname.trim()

			switch (this.dialogObj.type) {
				// 模板保存
				case 'template':
					if (params.sname === '') {
						this.$message.warning('请填写模板名称！')
						this.btnLoading = false
						return
					}

					this.saveApi(params, 'left')
					break
				// 事项保存
				case 'matter':
					if (params.applysArr.length === 0) {
						this.$message.warning('请选择适用任务类型！')
						this.btnLoading = false
						return
					}
					this.$refs.matterForm.validate((valid) => {
						if (!valid) {
							this.btnLoading = false

							return
						}

						params.applys = params.applysArr.join(',')
						this.saveApi(params)
					})
					break
			}
		},

		// 接口保存
		saveApi(params, type) {
			Api.saveOrUpdate(params)
				.then((res) => {
					this.dialogObj.show = false
					this.btnLoading = false

					// 重载树
					type === 'left' ? this.getLeftData() : this.handleSearch()
				})
				.catch((err) => {
					this.btnLoading = false
				})
		},

		// 反转函数
		reverseTable(columns, list) {
			let _list = $deepCopy(list, 'Array')
			const buildData = columns.map((column) => {
				const item = { col0: column.title }
				_list.forEach((row, index) => {
					item[`col${index + 1}`] = row[column.field]
				})
				return item
			})
			const buildColumns = [
				{
					field: 'col0',
					fixed: 'left',
					width: 200,
				},
			]
			_list.forEach((item, index) => {
				buildColumns.push({
					field: `col${index + 1}`,
					minWidth: 120,
					slots: {
						// 使用插槽模板渲染
						default: 'default',
					},
				})
			})
			this.gridOptions.data = buildData
			this.gridOptions.columns = buildColumns
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),
		...mapState('menu', {
			roleBtnsArr: (state) => state.roleBtns,
		}),
		...mapState('user', {
			// 运维角色
			isMaintenance: (state) => state.isMaintenance,
		}),
		roleBtns() {
			return this.isMaintenance ? ['status'] : this.roleBtnsArr
		},
		// 处理禁用
		isDisabled() {
			return this.isMaintenance
		},

		// 反转表格固定列
		columns() {
			return [
				{ field: 'sname', title: '名称：' },
				{ field: 'content', title: '内容：' },
				{ field: 'requires', title: '审计要求：' },
				{ field: 'gist', title: '依据：' },
				{ field: 'typeName', title: '评价方式：' },
				{ field: 'status', title: '是否生效：' },
				{ field: 'applysName', title: '适用任务类型：' },
				{ field: 'remark', title: '备注：' },
				{ field: 'createUserName', title: '创建人：' },
				{ field: 'createDate', title: '创建时间：' },
				{ field: 'updateUserName', title: '更新人：' },
				{ field: 'updateDate', title: '更新时间：' },
			]
		},
	},
	watch: {
		// 监听弹窗
		'dialogObj.show'(status) {
			if (!status) {
				this.dialogObj.type = ''

				this.addParams.id = ''
				this.addParams.sname = ''
				this.addParams.pid = ''
				this.addParams.content = ''
				this.addParams.requires = ''
				this.addParams.gist = ''
				this.addParams.type = ''
				this.addParams.applys = ''
				this.addParams.applysArr = []
				this.addParams.sort = ''
				this.addParams.remark = ''
				this.addParams.status = ''

				this.gridOptions.data = []
				this.gridOptions.columns = []
			}
		},
	},
}
</script>

<style scoped lang="less">
.primary-header {
	padding: 0 15px;
	height: 50px;
	border-bottom: 1px solid #e8e8e8;

	.left-text {
		font-weight: 600;
		font-size: 16px;
	}
}

.left-pane,
.right-pane {
	padding: 15px;
}

.left-pane {
	overflow-y: auto;
}

.left-tree {
	width: 100%;
	overflow: hidden;
}

.reverse-table {
	/deep/ .vxe-body--row .vxe-body--column:first-child {
		background-color: #f8f8f9;
	}
}

.matter-view-main {
	.matter-view-header {
		line-height: 30px;
		font-size: 16px;
		font-weight: 600;
	}
}

.btn {
	padding: 0px 50px !important;
}
.w300 {
	/deep/.el-input__inner {
		width: 300px;
	}
}
</style>
